export default class Notices {
    constructor(elements) {
        elements.forEach((element) => {
            this.addBlurListener(element.inputElement, element.notice);
            this.addFocusListener(element.inputElement, element.notice);
        });
    }
    addBlurListener(inputElement, notice) {
        const input = document.querySelector(inputElement);
        input.addEventListener('blur', () => {
            const noticeBox = document.querySelector(notice);
            noticeBox.style.display = 'none';
        });
    }
    addFocusListener(inputElement, notice) {
        const input = document.querySelector(inputElement);
        input.addEventListener('focus', () => {
            const noticeBox = document.querySelector(notice);
            noticeBox.style.display = 'block';
        });
    }
}
